import { spacing, styled, mq, Text } from '@thg-commerce/enterprise-theme'
import { HorizontalAlignment } from '@thg-commerce/enterprise-core'

import { ProductBlock } from '@thg-commerce/enterprise-components'
import { Button } from '@thg-commerce/gravity-elements'

export const ProductBlockContainer = styled.div<{
  horizontalAlignment?: HorizontalAlignment
}>`
  text-align: ${(props) => props.horizontalAlignment};
  display: flex;
  row-gap: ${spacing(5)};
  flex-wrap: wrap;
  justify-content: ${(props) =>
    props.horizontalAlignment === 'right'
      ? 'end'
      : props.horizontalAlignment || 'left'};
`

export const ProductBlockItem = styled(ProductBlock)<{
  totalItems: number
}>`
  margin: auto;
  flex-basis: calc(50% - ${spacing(3)} - 2px);

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    flex-basis: ${(props) =>
      props.totalItems === 2
        ? `calc(50% - ${spacing(3)} - 2px)`
        : props.totalItems === 3
        ? `calc(33% - ${spacing(3)})`
        : `calc(25% - ${spacing(3)})`};
  }
`

export const Title = styled.h2<{
  marginBottom?: number
  horizontalAlignment: HorizontalAlignment
}>`
  text-align: ${(props) => props.horizontalAlignment};
  ${Text('large1', 'alternate')};
  margin-bottom: ${(props) =>
    props.marginBottom ? `${props.marginBottom}px` : spacing(1)};
`
export const Subtitle = styled.p<{
  marginBottom?: number
  horizontalAlignment: HorizontalAlignment
}>`
  text-align: ${(props) => props.horizontalAlignment};
  ${Text('bodyText', 'default')}
  margin-bottom: ${(props) =>
    props.marginBottom ? `${props.marginBottom}px` : spacing(3)};
`

export const CTAWrapper = styled.div<{
  marginTop?: number
  horizontalAlignment: HorizontalAlignment
}>`
  text-align: ${(props) => props.horizontalAlignment || 'left'};

  margin-top: ${spacing(4)};
  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    margin-top: ${spacing(5)};
  }
  margin-top: ${(props) =>
    props.marginTop && props.marginTop >= 32 && `${props.marginTop}px`};
`

export const StyledButton = styled(Button)`
  width: 100%;

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    width: max-content;
  }
`
